
import React from 'react';
import toast from 'react-hot-toast';
import useApi from '../useApi';
import {IBillingProvider, IBillingProviderRes} from './index.type';

const useFetchBillingProvider = ({ selectedAssociatedClinicId }: { selectedAssociatedClinicId: string | ""}) => {
  const [billingProvider, setBillingProvider] = React.useState<IBillingProvider[]>();
  const { loading:billingProviderLoading, makeApiCall } = useApi({
    url: `/rtm/billing-provider?associatedClinicianId=${selectedAssociatedClinicId}`,
    method: 'GET',
  });

  const getBillingProvider = async () => {
    const { response, error } = await makeApiCall<undefined, IBillingProviderRes>();
    if (response?.status) {

        setBillingProvider(response?.data);
    }

    if (!response?.status) {
        setBillingProvider(undefined);
    }

    if (error) toast.error('Something went wrong while fetching  billing provider. Please try again state');
  };

  return {
    billingProvider,
    getBillingProvider,
    billingProviderLoading
  };
};

export default useFetchBillingProvider;
